import { Icon } from 'ant-design-vue';

const MyIcon = Icon.createFromIconfontCN({
    scriptUrl: '/icon.js'
});

export default MyIcon;